/**
 * Uses `window.requestIdleCallback` if available, otherwise falls back to `window.setTimeout`.
 * Necessary because Safari doesn't support `window.requestIdleCallback` yet.
 */
export function requestIdleCallback(callback: () => void, options?: IdleRequestOptions) {
    return window.requestIdleCallback
        ? window.requestIdleCallback(callback, options)
        : window.setTimeout(callback)
}
